var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:['navigation-burger', { 'is-active': _vm.isActive }],attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('span'),_c('span'),_c('span')])}
var staticRenderFns = []

export { render, staticRenderFns }